<template>
  <div class="zonamanager">
    <navbar></navbar>
    <b-container style="height: 80vh;">
      <b-row style="height: 80%;">
          <b-col id="list-user">
            <h2>LISTA ZONE INSERITE</h2>
            <scrolly id="list">
              <scrolly-viewport>
                <b-list-group v-for="(value, index) in zone" :key="index">
                  <b-list-group-item v-if="index%2 == 0" v-on:click="modalZonaOpen(value)">{{value.nome}}</b-list-group-item>
                  <b-list-group-item variant="secondary" v-else v-on:click="modalZonaOpen(value)">{{value.nome}}</b-list-group-item>
                </b-list-group>
              </scrolly-viewport>
              <scrolly-bar axis="y"></scrolly-bar>
              <scrolly-bar axis="x"></scrolly-bar>
            </scrolly>
          </b-col>
          <b-col id="add-user">
            <h2>AGGIUNGI NUOVA ZONA</h2>
            <br>
            <b-form v-on:submit.prevent="addZona">
              <b-input-group prepend="Nome">
                <b-form-input v-model="add.nome"></b-form-input>
              </b-input-group>
              <br>
              <b-input-group prepend="Colore">
                <b-form-input type="color" v-model="add.colore"></b-form-input>
              </b-input-group>
              <br>
              <b-input-group prepend="Comuni">
                <b-form-select multiple :select-size="4" v-model="add.comuni" :options="comuni"></b-form-select>
              </b-input-group>
              <br>
              <b-button style="float: right;" v-on:click="setComuni()">Applica comuni</b-button>
              <br>
              <br>
              <h5 v-if="comuniResult.length">Seleziona il poligono corretto dei comuni selezionati:</h5>
              <b-list-group v-for="(value, index) in comuniResult" :key="index">
                <b-form-select text-field="display_name" value-field="geojson" v-model="comuniSelected[index]" :options="value"></b-form-select>
                <br>
              </b-list-group>
              <b-button v-if="comuniSelected.length" style="float: right;" v-on:click="setMap()">Genera Mappa</b-button>
              <br>
              <br>
              <div id='map' style="height: 400px"></div>
              <br>
              <b-button type="submit" style="float: right;" variant="success">Aggiungi zona</b-button>
            </b-form>
          </b-col>
      </b-row>
  </b-container>
  <b-modal v-model="modal.zona" title="Dettagli zona">
    <b-form v-on:submit.prevent="addZona">
      <b-input-group prepend="Nome">
        <b-form-input v-model="modaldata.nome" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Colore">
        <b-form-input v-model="modaldata.colore" type="color" disabled></b-form-input>
      </b-input-group>
      <br>
    </b-form>

    <div slot="modal-footer" class="w-100" v-if="!modal.zonadelete">
      <b-container>
        <b-row>
          <b-col><b-button variant="danger" size="sm" v-on:click="modal.zonadelete = true">Elimina</b-button></b-col>
          <b-col></b-col>
          <b-col><b-button variant="secondary" style="float: right;" v-on:click="modal.zona = false">Chiudi</b-button></b-col>
        </b-row>
      </b-container>
    </div>
    <div slot="modal-footer" class="w-100" v-else>
      <p style="float: left;">Si sta eliminando questo utente, proseguire?</p>
      <b-button variant="secondary" style="float: right; margin-left: 10px;" v-on:click="modal.userdelete = false">No</b-button>
      <b-button variant="danger" style="float: right;" v-on:click="deleteZona(modaldata.id)">Si</b-button>
    </div>
  </b-modal>
  </div>
  
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import mapboxgl from 'mapbox-gl'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly'
import * as turf from '@turf/turf'

var map
var draw

export default {
  name: 'zonamanager',
  components: {
    navbar,
    Scrolly,
    ScrollyViewport,
    ScrollyBar
  },
  data() {
    return {
      accessToken: "pk.eyJ1IjoidGhlZmxhc2htb2I5NyIsImEiOiJjamxmYWFvdTcwc2FlM3Byb2JrbDdteDdqIn0.hCieGkbt2_aHZATJCECZ2w", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/theflashmob97/cjlf9q2uh044y2spiirdmu5jg",// your map style
      zone: [],
      comuni: [],
      add: {
        nome: "",
        colore: "#000000",
        coordinate: [],
        comuni: []
      },
      modal: {
        zona: false,
        zonadelete: false
      },
      modaldata: {},
      comuniResult: [],
      comuniSelected: []
    }
  },
  mounted: function () {
    this.createMap()
  },
  created: function(){
        this.updateZone()
        this.updateComuni()
  },
  methods: {
    createMap(){
      mapboxgl.accessToken = this.accessToken
      map = new mapboxgl.Map({
          container: 'map',
          style: this.mapStyle,
          zoom: 10
      })

      map.addControl(new MapboxGeocoder({
          accessToken: mapboxgl.accessToken
      }))

      map.addControl(new mapboxgl.FullscreenControl())

      draw = new MapboxDraw({
      displayControlsDefault: false,
          controls: {
              polygon: true,
              trash: true
          }
      })
      map.addControl(draw)

      map.addControl(new mapboxgl.NavigationControl())
    },
    addZona() {
      this.add.coordinate = this.setPolygon(draw.getAll().features[0].geometry.coordinates)

      if(this.add.nome != "" && this.add.colore != "" && this.add.coordinate.length > 0 && this.add.comuni.length > 0){
        Vue.http.post(this.$hostlink+'zona/add', this.add, {credentials : true}).then(response => {
          if(response.body.success){
            this.add.nome = ""
            this.add.colore = "#000000"
            this.add.coordinate = []
            this.add.comuni = []
            draw.deleteAll()

            this.updateZone()
            this.updateComuni()
            Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Zona creata con successo!',
              type: 'success'
            })
          }else{
            this.emailState = false
            Vue.notify({
              group: 'global',
              title: 'Errore durante la creazione!',
              text: response.body.msg,
              type: 'error'
            })
          }
        }, response => {
          Vue.notify({
            group: 'global',
            title: 'Errore di comunicazione',
            text: 'Errore di comunicazione con i server!',
            type: 'error'
          })
        })
      }else{
        Vue.notify({
          group: 'global',
          title: 'Dati non inseriti correttamente',
          text: 'Assicurati di aver inserito tutti i dati correttamente!',
          type: 'error'
        })
      }
    },
    setPolygon(polygon){
      console.log(polygon)
      
      if(polygon[0][0][0]){
        if(polygon[0][0][0][0]){
          return polygon
        }else{
          return [polygon]
        }
      }else{
        return 
      }
    },
    updateZone(){
      Vue.http.post(this.$hostlink+'zona/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.zone = response.body.data
        }
      }, response => {
          // error callback
      })
    },
    deleteZona(id){
      Vue.http.post(this.$hostlink+'zona/delete', {id: id}, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione eseguita',
            text: 'Zona eliminata con successo!',
            type: 'success'
          })
        }else
          Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: 'Errore durante l\'eliminazione della zona. Verificare se non è stato precedentemente eliminato!',
            type: 'error'
          })
        this.modal.zona = false
        this.updateZone()
      }, response => {
        Vue.notify({
          group: 'global',
          title: 'Errore!',
          text: 'Errore durante la comunicazione con il server!',
          type: 'error'
        })
      })
    },
    updateComuni(){
      Vue.http.post(this.$hostlink+'zona/list/comuni', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.comuni = response.body.data
        }
      }, response => {
          // error callback
      })
    },
    modalZonaOpen(zona){
      this.modaldata = zona
      this.modal.zonadelete = false
      this.modal.zona = true
    },
    setComuni(){
      this.comuniResult = []
      this.comuniSelected = []

      for(var i=0; i<this.comuni.length; i++){
        if(this.add.comuni.indexOf(this.comuni[i].value) != -1)
        Vue.http.get('https://nominatim.openstreetmap.org/search.php', {params: {q: this.comuni[i].text.split("-")[1].trim()+",Italy", polygon_geojson: 1, format: "json"}}, {credentials : true}).then(response => {
          if(response.body.length > 0)
            try{
              this.comuniSelected.push(response.body[0].geojson)
              this.comuniResult.push(response.body)
            }catch(e){
              console.log("Geojson non trovato: "+e)
            }
        })
      }
    },
    setMap(){
      this.createMap()

      var comuni = this.comuniSelected.filter(x => !!x)

      map.on('load', function () {

        if(comuni[0].coordinates[0][0]){
          if(comuni[0].coordinates[0][0][0]){
            map.flyTo({center: comuni[0].coordinates[0][0]})
          }else{
            map.flyTo({center: comuni[0].coordinates[0]})
          }
        }else{
          map.flyTo({center: comuni[0].coordinates})
        }

        var union
        var defined = false
        for(var i=0; i<comuni.length; i++){
          if(defined){
            try{
              var p
              p = turf.polygon(comuni[i].coordinates)
              union = turf.union(union, p)
            }catch(e){
              console.log("unione: "+e)
            }
          }

          if(!defined){
            try{
              union = turf.polygon(comuni[i].coordinates)
              defined = true
            }catch(e){
              console.log("inizio: "+e)
            }
          }
        }

        map.addLayer({
            'id': 'Z',
            'type': 'fill',
            'source': {
                'type': 'geojson',
                'data': union
            },
            'layout': {
              'visibility': 'visible'
            },
            'paint': {
                'fill-color': '#000000',
                'fill-opacity': 0.5
            }
        })

        draw.add(union)

        for(var i=0;i<Vue.prototype.$sidebarData.zona.data.length; i++){
          if(Vue.prototype.$sidebarData.zona.data[i].coordinate){
            map.addLayer({
                'id': 'ZC'+i,
                'type': 'fill',
                'source': {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'MultiPolygon',
                            'coordinates': JSON.parse(Vue.prototype.$sidebarData.zona.data[i].coordinate)
                        }
                    }
                },
                'layout': {
                  'visibility': 'visible'
                },
                'paint': {
                    'fill-color': Vue.prototype.$sidebarData.zona.data[i].colore,
                    'fill-opacity': 0.5
                }
            })
          }
        }
      })
    }
  }
}
</script>

<style>
#list-user{
  margin-top: 10%;
}

#list{
  height: 100%;
}

#add-user{
  margin-top: 10%;
  height: 100%;
}
</style>
